import { useRef } from 'react';
import { useMountEffect } from './useMountEffect';

export function useWindowEvent<K extends keyof WindowEventMap>(
    type: K,
    handler: (event: WindowEventMap[K]) => void,
    options?: boolean | AddEventListenerOptions,
    enabled?: boolean
): void;
export function useWindowEvent(
    type: string,
    handler: (event: Event) => void,
    options?: boolean | AddEventListenerOptions,
    enabled?: boolean
): void;
export function useWindowEvent(
    type: string,
    handler: (event: Event) => void,
    options?: boolean | AddEventListenerOptions,
    enabled = true
): void {
    const handlerRef = useRef(handler);
    handlerRef.current = handler;
    const enabledRef = useRef(enabled);
    enabledRef.current = enabled;

    useMountEffect(() => {
        const listener = (event: Event) => {
            if (enabledRef.current) {
                handlerRef.current(event);
            }
        };
        window.addEventListener(type, listener, options);
        return () => window.removeEventListener(type, listener, options);
    });
}
